import * as global from '../global.js';

async function sendNotification(title, message, url, url_title) {
    try {
        const environment = global.get_environment();
        const response = await fetch('https://api.pushover.net/1/messages.json', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: "amzmwvxw52b9mrqygvk1vsr9cin4mn",
                user: "uaq22smbybzxun7pc65g9cuhvpxccq",
                title: (environment === "PROD" ? "" : "[PP] ") + title,
                message: message,
                url: url || null,
                url_title: url_title || null,
            })
        });
        // const response_json = await response.json();
        // console.log('ERROR NOTIFICATION SENT TO ADMIN TEAM');
    } catch (error) {
        // console.error('Oops!', error);
    }
}

export const sendPushoverNotification = (title, message, url, url_title) => {
    sendNotification(title, message, url, url_title);
}